import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QAOffering from "@/pages/QAOffering";

export const Route = createFileRoute("/en/services/quality-assurance/qp-rp-prrc-services")({
  head: () => buildRouteHead("/en/services/quality-assurance/qp-rp-prrc-services"),
  component: QAOffering,
});
